module.exports = __webpack_public_path__ + "img/Sustainability_at_DTCC.614591d1.jpg";